<template>
  <div>
    <span>Промокод: XXXX-XXXX-XXXX</span>
    <v-btn>Сгенерировать</v-btn>
    <br>
    <span>Количество активаций</span>
    <v-text-field class="field" />
    <br>
    <span>Вознаграждение (монеты)</span>
    <v-text-field class="field" />
    <br>
    <Base--SideButtons :save="f" back />
  </div>
</template>

<script>
export default {
  data: () => ({
    f: () => console.log('saved')
  })
}
</script>